module.exports={otherOrganizations:"Otras organizaciones",solutionIframe:"Contenido principal",unloadPromptMessage:"¿Está seguro?"};